import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { browserHistory, withRouter } from "react-router";
import PropTypes from "prop-types";
import Form from "./Form";
import helper from "./helper";
import FormDefaultData from "./formDefaultData";
import api from "./api";
import "./RiskQuestionnaire.style.scss";

class RiskQuestionnaire extends Component {
  state = {
    postDataFailed: false,
    isProcessingPortfolio: false,
    formSubmittedSuccessfully: false,
    showMyClientButton: false,
  };

  postRequest = ({
    age,
    full_name,
    household_health,
    zip_code,
    own_house,
    adult_in_household,
    children_in_house,
    industry_employed_in,
    annual_income,
    annual_expenses,
    net_worth,
    income_consistency,
    investment_amount,
    investment_period,
    max_loss,
  }) => {
    const household_body_count = adult_in_household * 1 + children_in_house * 1;
    const addHyphen = (txt) => {
      return txt.split(" ").join("-");
    };

    const _income_consistency = addHyphen(income_consistency);
    const _industry_employed_in = addHyphen(industry_employed_in);
    const _household_health = addHyphen(household_health);

    this.setState({
      isProcessingPortfolio: true,
    });

    function getSession() {
      let myHeaders = new Headers();
      myHeaders.append("token", "20cec681c6c44aaeaf7ce64cfaeda595");
      myHeaders.append("Content-Type", "application/json");

      let raw = JSON.stringify({
        email: "rajeev.nedunuri@iqcio.com",
        password: "Rajeev123$",
      });

      let requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };
      return new Promise((resolve, reject) => {
        fetch("https://dev.platform.totumrisk.com/v1/sessions", requestOptions)
          .then((res) => res.json())
          .then((data) => {
            if (data) {
              resolve(data.token);
            }
          })
          .catch((err) => reject(err));
      });
    }

    function postFormData(token) {
      return new Promise((resolve, reject) => {
        let myHeaders = new Headers();
        myHeaders.append("token", token);
        myHeaders.append("Content-Type", "application/json");
        let raw = JSON.stringify({
          "financial-income": `${annual_income}`, //ANNUAL INCOME
          "financial-expenses": `${annual_expenses}`, //ANNUAL EXPENSES
          "financial-net-worth-override": `${net_worth}`, //NET WORTH
          "income-consistency": `pay-${_income_consistency}`, //INCOME CONSISTENCY - pay-will-grow FOR GROW
          "investment-amount": `${investment_amount}`, //INVESTMENT AMOUNT
          "investment-period": `${investment_period}`, //INVESTMENT PERIOD
          "investment-max-loss": `${max_loss}`, //MAX LOSS
          "industry-sectors-impacting-household": [
            `industry-${_industry_employed_in}`,
          ],
          //INDUSTRY EMPLOYED IN - industry-industrials FOR INDUSTRIAL
          // name: `${full_name}`,
          age: `${age}`, //AGE
          "household-health": `${_household_health}`, //FIXED VALUE  AS HOUSEHOLD-HEAD
          "geo-zip-code": `${zip_code}`, //ZIP CODE
          "geo-zip-code-owner": `${own_house}`, //OWN HOUSE - true/false FOR YES/NO
          "household-body-count": `${household_body_count}`, //ADULTS + CHILDREN
          "household-body-count-under-18": `${children_in_house}`, //CHILDREN UNDER 18
        });

        let requestOptions = {
          method: "POST",
          headers: myHeaders,
          body: raw,
          redirect: "follow",
        };
        fetch(
          "https://dev.platform.totumrisk.com/v1/riskscore/questionnaire",
          requestOptions
        )
          .then((res) => res.json())
          .then((data) => {
            resolve(data);
          })
          .catch((err) => reject(err));
      });
    }

    getSession()
      .then((res) => postFormData(res))
      .then((res) => {
        console.log(res);
        if (res && res.status.toLowerCase() === "error") {
          throw new Error("failed to submit data");
        }
        this.setState({
          isProcessingPortfolio: false,
          formSubmittedSuccessfully: true,
        });
        this.props.setRiskQuestionnaire(res);
        // this.props.riskQuestionareDataHandler(res);
        if (
          this.props.create_new_questionnaire_client === false &&
          this.props.myClientButtonActionType !== "edit" &&
          this.props.stepHandler
        ) {
          this.props.stepHandler();
        }
        // sending results to ajax_create_client_profile along with dob and name
        if (res) {
          let _dob = helper.formatDate(this.props.dob);
          api
            .creteClientProfile({
              data: {
                client_name: this.props.full_name,
                client_dob: _dob, //mm/dd/yyyy
                risk_profile: {
                  ...res,
                },
              },
              client_id: this.props.client_id,
            })
            .then((data) => {
              console.log(data, "res from client_profile");
              setTimeout(() => {
                this.setState({
                  formSubmittedSuccessfully: false,
                  showMyClientButton: true,
                });
              }, 2000);
            });
        }
        setTimeout(() => {
          this.setState({
            formSubmittedSuccessfully: false,
            showMyClientButton: true,
          });
        }, 2000);
      })
      .catch((err) => {
        this.setState({
          postDataFailed: true,
          isProcessingPortfolio: false,
          formSubmittedSuccessfully: false,
        });

        setTimeout(() => {
          this.setState({
            postDataFailed: false,
          });
        }, 1000);
      });
  };

  formSubmitHandler = (event) => {
    event.preventDefault();
    if (this.state.showMyClientButton) {
      return;
    }
    const {
      age,
      full_name,
      household_health,
      zip_code,
      own_house,
      adult_in_household,
      children_in_house,
      industry_employed_in,
      annual_income,
      annual_expenses,
      net_worth,
      income_consistency,
      investment_amount,
      investment_period,
      max_loss,
    } = this.props;
    this.postRequest({
      age,
      full_name,
      household_health,
      zip_code,
      own_house,
      adult_in_household,
      children_in_house,
      industry_employed_in,
      annual_income,
      annual_expenses,
      net_worth,
      income_consistency,
      investment_amount,
      investment_period,
      max_loss,
    });
  };

  changeHandler = (event) => {
    event.preventDefault();
    let { name, value } = event.target;
    if (!name || !value) {
      name = event.target.getAttribute("name");
      value = event.target.getAttribute("value");
    }
    if (name && name.length && name.toLowerCase() === "dob") {
      let age = helper.getAge(value);

      this.props.questionnaireFormHandler({ name, value });
      this.props.questionnaireFormHandler({ name: "age", value: age });
    } else {
      this.props.questionnaireFormHandler({ name, value });
    }
  };

  myClientNavHandler = () => {
    browserHistory.push("/myclients");
  };
  render() {
    const {
      postDataFailed,
      isProcessingPortfolio,
      formSubmittedSuccessfully,
      showMyClientButton,
    } = this.state;
    const {
      adult_in_household,
      annual_expenses,
      annual_income,
      children_in_house,
      dob,
      full_name,
      household_health,
      income_consistency,
      industry_employed_in,
      investment_amount,
      investment_period,
      max_loss,
      net_worth,
      own_house,
      zip_code,
      create_new_questionnaire_client,
      myClientButtonActionType,
    } = this.props;
    return (
      <Fragment>
        <div className="riskQuestionnaire container-fluid">
          <div className="riskQuestionnaire__heading text-center text-uppercase clearfix">
            <span>Risk Questionnaire</span>
          </div>
          <p className="riskQuestionnaire__desc text-center clearfix">
            Please answer the below questions to asses the risk appetite and
            recommend the appropriate Model Portfolio.
          </p>
          <form
            onSubmit={
              showMyClientButton
                ? this.myClientNavHandler
                : this.formSubmitHandler
            }
            className="clearfix"
          >
            <div className="riskQuestionnaire__form">
              <Form
                // age={age}
                dob={dob}
                full_name={full_name}
                household_health={household_health}
                zip_code={zip_code}
                own_house={own_house}
                adult_in_household={adult_in_household}
                children_in_house={children_in_house}
                industry_employed_in={industry_employed_in}
                annual_income={annual_income}
                annual_expenses={annual_expenses}
                net_worth={net_worth}
                income_consistency={income_consistency}
                investment_amount={investment_amount}
                investment_period={investment_period}
                max_loss={max_loss}
                changeHandler={this.changeHandler}
              />
            </div>
            <div className="riskQuestionnaire__button text-uppercase clearfix">
              <div className="riskQuestionnaire__button__left">
                {isProcessingPortfolio ? (
                  <span>
                    <i className={`fa fa-spinner fa-spin fa-1x`} /> Please wait
                    for a minute or a while, your model portfolio is being
                    process.
                  </span>
                ) : null}
                {formSubmittedSuccessfully &&
                (create_new_questionnaire_client ||
                  myClientButtonActionType === "edit") ? (
                  <span>
                    Client Details{" "}
                    {`${
                      myClientButtonActionType === "edit"
                        ? "edited"
                        : "submitted"
                    }`}{" "}
                    successfully.
                  </span>
                ) : null}
                {showMyClientButton &&
                (create_new_questionnaire_client ||
                  myClientButtonActionType === "edit") ? (
                  <Fragment>
                    <button
                      onClick={this.myClientNavHandler}
                      style={{ width: "100%" }}
                    >
                      {" "}
                      <i className="fa fa-chevron-left"></i> my Clients
                    </button>
                  </Fragment>
                ) : null}
              </div>
              <div className="riskQuestionnaire__button__right">
                {create_new_questionnaire_client ||
                myClientButtonActionType === "edit" ? (
                  <button type="submit">
                    {showMyClientButton ? "DONE" : "SAVE"}
                  </button>
                ) : (
                  <button type="submit">
                    Next <i className="fa fa-chevron-right"></i>
                  </button>
                )}
              </div>
            </div>
            <div className="riskQuestionnaire__warning clearfix">
              {postDataFailed ? (
                <span className="dataWarning">
                  Failed to submit data please try again later.
                </span>
              ) : null}
            </div>
          </form>
        </div>
      </Fragment>
    );
  }
}

RiskQuestionnaire.propTypes = {
  stepHandler: PropTypes.func.isRequired,
  // riskQuestionareDataHandler: PropTypes.func.isRequired,
  // setRiskQuestionnaire: PropTypes.func,
};
export default connect(
  ({
    buildPortfolio: {
      model_portfolios: {
        riskQuestionnaireFormData: {
          adult_in_household,
          age,
          annual_expenses,
          annual_income,
          children_in_house,
          dob,
          full_name,
          household_health,
          income_consistency,
          industry_employed_in,
          investment_amount,
          investment_period,
          max_loss,
          net_worth,
          own_house,
          zip_code,
        },
        create_new_questionnaire_client,
      },
    },
    myClients: { myClientButtonActionType, client_id },
  }) => ({
    adult_in_household,
    age,
    annual_expenses,
    annual_income,
    children_in_house,
    dob,
    full_name,
    household_health,
    income_consistency,
    industry_employed_in,
    investment_amount,
    investment_period,
    max_loss,
    net_worth,
    own_house,
    zip_code,
    client_id,
    create_new_questionnaire_client,
    myClientButtonActionType,
  }),

  (dispatch) => ({
    questionnaireFormHandler: ({ value, name }) =>
      dispatch({
        type: "BUILD_A_PORTFOLIO_SET_RISK_QUESTIONNAIRE_FORM_DATA",
        payload: { value, name },
      }),
    setRiskQuestionnaire: (payload) =>
      dispatch({
        type: "BUILD_A_PORTFOLIO_SET_RISK_QUESTIONNAIRE",
        payload,
      }),
  })
)(RiskQuestionnaire);



// WEBPACK FOOTER //
// ./src/components/pages/Create_portfolio_by_Advisor/model_portfolio/riskQuestionnaire/RiskQuestionnaire.jsx